module.exports = __webpack_public_path__ + "img/XVC.3543ce38.svg";